export const useUsuario = () => {
  const useBase = useBaseStore(`/gerencial/usuario`)
  return {
    ...useBase
  }
}
